export default __webpack_public_path__ + "static/media/anderlecht.c0d1d646.webp";